/** Master data for TYRE REPLACEMENT item category */

export const TYRE_BRAND_OPTIONS = [
  "Michelin",
  "Bridgestone",
  "Goodyear",
  "Continental",
  "Pirelli",
  "Dunlop",
  "Yokohama",
  "Sumitomo",
  "Toyo",
  "Falken",
  "Hankook",
  "Kumho",
  "Nexen",
  "Roadstone",
  "Maxxis",
  "Nitto",
  "MRF",
  "Apollo",
  "CEAT",
  "BKT",
  "Giti",
  "Sailun",
  "Linglong",
  "Triangle",
  "Westlake",
  "Goodride",
  "Aeolus",
  "Double Coin",
  "Double Star",
  "Roadone",
  "Longmarch",
  "Kapsen",
  "Firemax",
  "Wanli",
  "Hifly",
  "Rotalla",
  "Roadking",
  "Powertrac",
  "Centara",
  "Royal Black",
  "Comforser",
  "Prinx",
  "Fortune",
  "Austone",
  "Rydanz",
  "Durun",
  "Fullrun",
  "Habilead",
  "PallyKing",
  "Lassa",
  "Otani",
  "Deestone",
  "CAMSO",
  "Boto",
  "ITR",
  "Fulda",
  "Mitas",
  "Trelleborg",
  "Alliance",
].map((label) => ({
  value: label.replace(/[^A-Za-z0-9]/g, "").slice(0, 4).toUpperCase(),
  label,
}));

export const TYRE_WIDTH_OPTIONS = [
  "6",
  "7",
  "7.5",
  "8",
  "8.25",
  "9",
  "9.5",
  "10",
  "11",
  "12",
  "13",
  "14",
  "16",
  "145",
  "155",
  "165",
  "175",
  "185",
  "195",
  "205",
  "215",
  "225",
  "235",
  "245",
  "255",
  "265",
  "275",
  "285",
  "295",
  "305",
  "315",
  "325",
  "335",
  "345",
  "355",
  "365",
  "375",
  "385",
  "395",
  "405",
  "425",
  "435",
  "445",
].map((v) => ({ value: v, label: v }));

export const TYRE_ASPECT_RATIO_OPTIONS = [
  "25",
  "30",
  "35",
  "40",
  "45",
  "50",
  "55",
  "60",
  "65",
  "70",
  "75",
  "80",
  "85",
  "90",
  "95",
  "N/A",
].map((v) => ({ value: v, label: v }));

export const TYRE_RIM_OPTIONS = [
  "10",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "17.5",
  "18",
  "19",
  "19.5",
  "20",
  "21",
  "22",
  "22.5",
  "23",
  "24",
  "25",
  "26",
  "28",
  "30",
  "32",
  "33",
  "34",
  "35",
  "36",
  "38",
  "40",
  "42",
  "44",
  "46",
  "48",
  "49",
  "51",
  "54",
  "57",
  "63",
].map((v) => ({ value: v, label: v }));

export const TYRE_LOAD_INDEX_OPTIONS = Array.from({ length: 280 }, (_, i) => ({
  value: String(i),
  label: String(i),
}));

export const TYRE_SPEED_RATING_OPTIONS = [
  "A1",
  "A2",
  "A3",
  "A4",
  "A5",
  "A6",
  "A7",
  "A8",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "J",
  "K",
  "L",
  "M",
  "N",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "H",
  "V",
  "W",
  "Y",
  "ZR",
  "(Y)",
].map((v) => ({ value: v, label: v }));

export const TYRE_APPLICATION_OPTIONS = [
  "HT",
  "AT",
  "MT",
  "Performance",
  "Touring",
  "All Season",
  "Winter",
  "Highway / Long Haul",
  "Regional",
  "Urban",
  "Mixed Service",
  "Off-Road",
  "Construction",
  "Mining",
  "Port / Terminal",
  "Trailer",
  "Agricultural",
  "Industrial",
  "OTR – Earthmover",
  "OTR – Quarry",
  "OTR – Sand / Desert",
  "OTR – Forklift",
  "Airport / Ground Support",
  "Military / Special Service",
  "Temporary",
].map((v) => ({ value: v, label: v }));

export const TYRE_XL_REINFORCED_OPTIONS = [
  { value: "Standard", label: "Standard" },
  { value: "XL – Extra Load", label: "XL – Extra Load" },
  { value: "Reinforced (RF)", label: "Reinforced (RF)" },
];

export const TYRE_RUN_FLAT_OPTIONS = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];

export const isTyreReplacementCategory = (category: any) => {
  // Prefer original English `title` so translated labels still match.
  const label = String(category?.title || category?.label || "").toLowerCase();
  return (
    label.includes("tyre replacement") || label.includes("tire replacement")
  );
};

/**
 * API may return itemDescriptions keys as camelCase or all-lowercase
 * (e.g. aspectRatio vs aspectratio).
 */
export const getTyreDescriptionValue = (
  desc: Record<string, unknown> | null | undefined,
  ...keys: string[]
): string => {
  if (!desc || typeof desc !== "object") return "";
  for (const key of keys) {
    const direct = desc[key];
    if (direct != null && String(direct).trim() !== "") return String(direct);
    const lower = desc[key.toLowerCase()];
    if (lower != null && String(lower).trim() !== "") return String(lower);
  }
  return "";
};

export const buildTyreSize = (
  width?: string | null,
  aspectRatio?: string | null,
  rim?: string | null,
) => {
  if (!width || !rim) return "";
  if (!aspectRatio || aspectRatio === "N/A") return `${width}R${rim}`;
  return `${width}/${aspectRatio}R${rim}`;
};

export const buildTyrePartNo = (
  brandCode?: string | null,
  width?: string | null,
  aspectRatio?: string | null,
  rim?: string | null,
) => {
  if (!brandCode || !width || !rim) return "";
  const aspectPart =
    !aspectRatio || aspectRatio === "N/A"
      ? ""
      : String(aspectRatio).replace(".", "");
  const sizeCode = `${String(width).replace(".", "")}${aspectPart}${String(rim).replace(".", "")}`;
  return `TYR-${brandCode}-${sizeCode}`;
};
